<template>
  <div class="offline">
    <div class="w1200Auto offline_box">
      <div class="hotTitle">
        <p class="hotTitle_l">线下撮合</p>
        <p class="hotTitle_r" @click="getMore">查看更多 ></p>
      </div>
      <div class="offline_mesg">
        <div class="offline_mesgL" @click="getSolutionDetail(lineCaseL.uuid)">
          <img :src="lineCaseL.pictureUrl" alt="" />
          <div class="offline_mesgL_con">
            <p class="offline_mesgL_con_tit">
              {{ lineCaseL.title }}
            </p>
            <p class="offline_mesgR_summary">
              {{ lineCaseL.summary }}
            </p>
          </div>
        </div>
        <div class="offline_mesgR">
          <div class="offline_mesgR_box" v-for="(item, index) in lineCaseR" :key="index" @click="getSolutionDetail(item.uuid)">
            <p class="offline_mesgR_box_tit">
              {{ item.title }}
            </p>
            <p class="offline_mesgR_summary">
              {{ item.summary }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {lineCaseList} from "../../utils/interface";

export default {
  data() {
    return {
      lineCaseL:{},
      lineCaseR:[],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init(){
      let param={
        current:1,
        pageSize:4
      }
      lineCaseList(param).then((res)=>{
        if(res.total>0){
          res.data.forEach((item,index)=>{
            console.log("------index---------"+index)
            if(index==0){
              this.lineCaseL = item;
            }else {
              this.lineCaseR.push(item);
            }
          })
          console.log("------lineCaseL---------",this.lineCaseL )
          console.log("------lineCaseR---------",this.lineCaseR )
        }
      })
    },
    getMore() {
      let routeData = this.$router.resolve({
        path: "/offlineList",
      });
      window.open(routeData.href, "_blank");
    },
    getSolutionDetail(uuid){
      let routeData = this.$router.resolve({
        name: `lineDetails`,
        params: {uuid:uuid}
      });
      window.open(routeData.href, "_blank");
    }
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.offline_mesgR_summary {
  overflow:hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-height: 22px;
}
.offline {
  background: url(../../assets/supplyHome/offlinebanner.png) no-repeat;
  background-size: 100% 100%;
  padding: 36px 0 20px;
  .offline_box {
    .offline_mesg {
      display: flex;
      justify-content: space-between;
      .offline_mesgL {
        margin-right: 21px;
        cursor: pointer;
        img {
          width: 468px;
          height: 222px;
          flex-shrink: 0;
          display: block;
        }
        .offline_mesgL_con {
          background: rgba(255, 255, 255, 0.498);
          width: 468px;
          padding: 14px 17px;
          font-size: 14px;
          box-sizing: border-box;
          color: #33333367;
          height: 136px;
          .offline_mesgL_con_tit {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            margin-bottom: 6px;
          }
        }
      }
      .offline_mesgR {
        width: 100%;
        .offline_mesgR_box {
          cursor: pointer;
          background: rgba(255, 255, 255, 0.498);
          margin-bottom: 20px;
          padding: 12px 28px;
          font-size: 14px;
          color: #33333367;
          height: 105px;
          box-sizing: border-box;
          .offline_mesgR_box_tit {
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            margin-bottom: 13px;
          }
          
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/offline.vue